/*=========================================================================================
  File Name: moduleCurrency.js
  Description: Currency Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleCurrencyState.js'
import mutations from './moduleCurrencyMutations.js'
import actions from './moduleCurrencyActions.js'
import getters from './moduleCurrencyGetters.js'

export default {
	namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
    getters: getters
}
